import { createStore } from "vuex";

const playlist = {
  state: () => ({
    ids: [],
    cursor: 0,
  }),
  mutations: {
    // eslint-disable-next-line
    increment(state: any) {
      state.cursor++;
      state.cursor %= state.ids.length;
    },
    // eslint-disable-next-line
    decrement(state: any) {
      state.cursor--;
      state.cursor %= state.ids.length;
    },
    addList(state: any, id: string) {
      state.ids.push(id);
    },
    removeList(state: any, id: string) {
      const prev = state.ids[state.cursor];
      state.ids = state.ids.filter((e: string) => e !== id);
      if (prev !== state.ids[state.cursor]) { state.cursor--; }
    },
    setList(state: any, ids: Array<string>) {
      state.ids = ids;
    }
  },
  actions: {},
};

const query = {
  state: () => ({
    query: []
  }),
  mutations: {
    set(state: any, newQuery: any) {
      state.query = newQuery;
    }
  },
  actions: {},
}

const preview = {
  state: () => ({
    currentTime: 0
  }),
  mutations: {
    setCurrentTime(state: any, time: number) {
      state.currentTime = time;
    }
  },
  actions: {},
}

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: { list: playlist, query: query, preview: preview },
});
